import { render, staticRenderFns } from "./WsCrudFilter.vue?vue&type=template&id=6fbef473&"
import script from "./WsCrudFilter.vue?vue&type=script&lang=js&"
export * from "./WsCrudFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports